import styled from '@emotion/styled';

interface ButtonProps {
  background: string;
  color: string;
}

interface ITD {
  width: number;
}

export const TR = styled.tr`
  width: 100%;
  height: 70px;

  max-width: 1200px;
  margin-top: 20px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;

  text-transform: uppercase;
  background-color: white;
  border-radius: 5px;
`;

export const TD = styled.td<ITD>`
  width: ${({ width }) => (width ? `${width}px` : '50px')};
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  overflow-x: hidden;
  padding: 5px;
`;

export const Title = styled.div`
  color: #6fcaff;
  font-weight: 800;
  text-align: left;
`;

export const Text = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  margin-top: 5px;
  font-size: 12px;
  overflow-x: hidden;
`;

export const Status = styled.div<ButtonProps>`
  width: 130px;
  height: 40px;

  display: flex;
  align-items: center;

  padding-left: 10px;
  border-radius: 5px;
  color: ${({ color }) => (color ? color : '')};
  background-color: ${({ background }) => (background ? background : '')};

  div:first-of-type {
    background: ${({ color }) => (color ? color : 'white')};
    border-radius: 2px;
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }
  &:hover {
    cursor: pointer;
  }
`;
